import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgAngleRightMid = function SvgAngleRightMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46967 3.46967C8.76256 3.17678 9.23744 3.17678 9.53033 3.46967L16.1161 10.0555C17.19 11.1294 17.19 12.8705 16.1162 13.9445L16.1161 13.9445L9.53033 20.5303C9.23744 20.8232 8.76256 20.8232 8.46967 20.5303C8.17678 20.2374 8.17678 19.7626 8.46967 19.4697L15.0554 12.8839C15.5436 12.3957 15.5436 11.6042 15.0555 11.1161L8.46967 4.53033C8.17678 4.23744 8.17678 3.76256 8.46967 3.46967Z"
  })));
};

export { SvgAngleRightMid as ReactComponent };
//# sourceMappingURL=angle-right-mid.svg.js.map
